import type { IconSvgObject } from './types';

const ReceiptIndianRupeeIcon: IconSvgObject = [
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 8C11.933 8 13.5 9.567 13.5 11.5C13.5 13.433 11.933 15 10 15H9L14 16M9 11.5H16M9 8H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReceiptIndianRupeeIcon;
